import { sha256 } from "@noble/hashes/sha2.js";
import { bytesToHex, utf8ToBytes } from "@noble/hashes/utils.js";

/**
 * Normalización canónica de respuestas de acusación (C14/G-23):
 * minúsculas, sin marcas diacríticas (NFD + strip), espacios internos colapsados, trim.
 * "  Delía  ROCA " → "delia roca". La MISMA función corre en authoring (para generar
 * los hashes del caso) y en el juego (para evaluar) — si divergieran, ningún caso
 * sería resoluble.
 */
export function normalizeAnswer(value: string): string {
  return value
    .normalize("NFD")
    .replace(/\p{M}+/gu, "")
    .toLowerCase()
    .replace(/\s+/g, " ")
    .trim();
}

/**
 * sha256(salt|respuesta normalizada) en hex. La solución del caso viaja SOLO como
 * estos hashes (nunca en claro en el JSON del caso): abrir el archivo en un editor
 * no spoilea, y el feedback "N campos mal" se computa sin conocer la respuesta.
 */
export function hashAnswer(salt: string, value: string): string {
  return bytesToHex(sha256(utf8ToBytes(`${salt}|${normalizeAnswer(value)}`)));
}
